export default __webpack_public_path__ + "static/media/2_0122.7b88295f.webp";